import { Model } from "@vuex-orm/core";
import config from "../configs/Building";

import BuildingOwner from "./BuildingOwner";
import BuildingLot from "./BuildingLot";
import Meeting from "./Meeting";
import VotingCategory from "./VotingCategory";

export default class Building extends Model {
  // NOTE: Define as getter. Resolves problem with babel loader on web
  static get entity() {
    return "buildings";
  }
  static fields() {
    return {
      id: this.attr(null),
      agency_id: this.attr(null),
      media_id: this.attr(null),
      name: this.attr(null),
      slug: this.attr(null),
      address: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null), // ???: ..
      with_majority: this.attr(null),
      co_ownership: this.attr(null),
      majority_parts: this.attr(null),
      voting_limit: this.attr(null),
      status: this.attr(null),
      votes_per_mandate: this.attr(null),
      voting_limit_operator: this.attr(null),
      voting_includes_mandates: this.attr(null),
      parts_per_mandate: this.attr(null),
      asl: this.attr(null),
      aful: this.attr(null),
      legal: this.attr(null),
      building_owners: this.hasMany(BuildingOwner, "building_id"),
      building_lots: this.hasMany(BuildingLot, "building_id"),
      meetings: this.hasMany(Meeting, "building_id"),
      voting_categories: this.hasMany(VotingCategory, "building_id"),      
    };
  }

  static get apiConfig() {
    return config;
  }
}
